import { useEffect, useState } from "react";

const fetchDataForExport = () => {
  const dataForExport = JSON.parse(localStorage.getItem("exportData"));
  return dataForExport || [];
};

const ExportPage = () => {
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    const dataForExport = fetchDataForExport();
    setExportData(dataForExport);

    window.addEventListener("beforeunload", () => {
      localStorage.removeItem("exportData");
    });

    return () => {
      window.removeEventListener("beforeunload", () => {
        localStorage.removeItem("exportData");
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main>
      <div
        dangerouslySetInnerHTML={{
          __html: exportData.length ? exportData : "No data",
        }}
      ></div>
    </main>
  );
};

export default ExportPage;
